module.exports = __webpack_public_path__ + "static/media/grocery-slide-1.e5a9aff5.png";